const Banner = () => {
    return (
        <div className="w-full flex-col justify-start items-center gap-4 inline-flex">
            <div className="h-11 text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-[24px] lg:text-3xl font-extrabold font-['Open Sans']">
                Что такое APM?
            </div>
            <div className="self-stretch justify-center items-start inline-flex">
                <div className="text-center text-[#58493b] text-[10px] lg:text-xl font-normal font-['Open Sans']">
                    APM и observability помогают компаниям быть конкурентоспособными, <br className="hidden sm-420-block " />
                    улучшая качество бизнес-транзакций и работу <br className="hidden lg:block xl:block xxl:block" />
                    сервисов. Эти технологии <br className="hidden sm-420-block " /> позволяют отслеживать производительность, выявлять проблемы до их <br className="hidden sm-420-block " /> возникновения и <br className="hidden lg:block xl:block xxl:block" /> оперативно реагировать, что 
                    улучшает <br className="hidden sm-420-block " />
                    пользовательский опыт и повышает надежность сервисов. В условиях <br className="lg:block xl:block xxl:block" /> современного цифрового мира observability дает
                    значительное <br className="hidden sm-420-block " />
                    преимущество в предоставлении качественных услуг.
                </div>
            </div>
        </div>
    );
}

export default Banner;